import { useTranslation } from "react-i18next";

import { Badge } from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";

import { SYNC_STATUS_OPTIONS } from "./constants";
import { SingleStatusProps } from "./types";

const SingleStatus = ({ status }: SingleStatusProps) => {
    const { t } = useTranslation();

    const badgeColor = SYNC_STATUS_OPTIONS[status].badgeColor;

    const isBadgeColorInverted =
        SYNC_STATUS_OPTIONS[status].isBadgeColorInverted;

    return (
        <TooltipGeneral
            title={t(
                `Table details##device details##configuration##status tooltips##${status}`
            )}
            placement={TOOLTIP_PLACEMENT.Top}
        >
            <Badge color={badgeColor} inverted={isBadgeColorInverted}>
                {t(
                    `Table details##device details##configuration##status titles##${status}`
                )}
            </Badge>
        </TooltipGeneral>
    );
};

export default SingleStatus;
